import Prism from 'prismjs';

const KEYWORD_PHRASES = [
  'memang dei',
  'or is it',
  'one by one',
  'confirm need',
  'walao eh',
  'try see',
  'no need',
  'is it',
  'tak sama',
  'if not',
];

const KEYWORD_SINGLE = [
  'kosong',
  'mampus',
  'alamak',
  'dalam',
  'tapau',
  'tukar',
  'sampai',
  'gaodim',
  'abuden',
  'cannot',
  'jom',
  'nah',
  'eh',
  'can',
  'sama',
  'also',
  'dei',
];

function esc(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const phraseAlt = KEYWORD_PHRASES.sort((a, b) => b.length - a.length)
  .map((p) => p.split(/\s+/).map(esc).join('\\s+'))
  .join('|');

const singleAlt = KEYWORD_SINGLE.sort((a, b) => b.length - a.length)
  .map(esc)
  .join('|');

const keywordPattern = new RegExp(`(?:${phraseAlt})|\\b(?:${singleAlt})\\b`);

Prism.languages.bolehlang = {
  comment: {
    pattern: /\/\/[^\n]*/,
    greedy: true,
  },
  string: {
    pattern: /"(?:[^"\\]|\\.)*"/,
    greedy: true,
  },
  number: /\b\d+(?:\.\d+)?\b/,
  keyword: keywordPattern,
  punctuation: /[{}[\]();,.]/,
  operator: /(?:>=|<=|==|!=|[+\-*/%=<>!])/,
};

export function highlightBolehlang(code) {
  return Prism.highlight(code, Prism.languages.bolehlang, 'bolehlang');
}
